import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, Flag, CheckCircle2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { getMyChallenge } from "@/lib/api";

export default function WeeklyChallenge({ refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const d = await getMyChallenge();
        if (!cancelled) setData(d);
      } catch (e) {
        console.error("[WeeklyChallenge] Failed to fetch challenge:", e);
      }
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (!data) return null;

  const done = Boolean(data.completed_at);

  return (
    <motion.div
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-hammerl-card border-2 border-hammerl-ink shadow-brutal-sm"
      data-testid="weekly-challenge"
    >
      <div className="px-3 py-2 border-b-2 border-hammerl-ink bg-hammerl-corpblue text-white flex items-center justify-between">
        <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest">
          <Flag className="w-3 h-3" /> Galopp-Challenge · {data.week}
        </div>
        {done && (
          <div className="flex items-center gap-1 text-[10px] font-mono uppercase font-bold">
            <CheckCircle2 className="w-3 h-3" /> Erledigt
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="font-bold text-sm leading-tight">{data.challenge.name}</div>
        <div className="text-xs text-hammerl-pencil mt-0.5">{data.challenge.description}</div>
        <div className="flex items-baseline justify-between mt-2 font-mono text-xs">
          <span className="text-hammerl-pencil">Fortschritt</span>
          <span className="font-bold">{data.progress} / {data.target}</span>
        </div>
        <Progress value={data.percent} className="h-2 rounded-none bg-hammerl-sidebar border border-hammerl-ink [&>div]:bg-hammerl-corpblue mt-1" />
        <div className="flex items-center gap-1 mt-2 text-[10px] font-mono uppercase tracking-widest text-hammerl-pencil">
          <Sparkles className="w-3 h-3 text-hammerl-corpblue" /> Belohnung: +{data.challenge.reward_xp} XP
        </div>
      </div>
    </motion.div>
  );
}
